import { render } from "./CommonInput.vue?vue&type=template&id=06e02fe2&scoped=true&ts=true"
import script from "./CommonInput.vue?vue&type=script&lang=ts"
export * from "./CommonInput.vue?vue&type=script&lang=ts"

import "./CommonInput.vue?vue&type=style&index=0&id=06e02fe2&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e02fe2"]])

export default __exports__